import { useEffect, useRef } from 'react';
import { useGetIdentity } from 'react-admin';

const WIDGET_SRC = 'https://api.prasolmedia.com/widget.js';
const SCRIPT_KEY = 'hd_bbcc1a7b65f7f958b6324734';
const SCRIPT_ATTR = 'data-gk-panel-helpdesk-widget';
const USER_KEY = 'gise_panel_user';

function ensureStub() {
  if (typeof window === 'undefined') return;
  if (window.HelpdeskWidget && typeof window.HelpdeskWidget.setUser === 'function') {
    return;
  }
  window.HelpdeskWidget = {
    q: [],
    setUser(user) {
      this.q.push(user);
    },
    clearUser() {
      this.q.push({ __clear: true });
    },
  };
}

function readPanelUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function syncHelpdeskUser(user) {
  ensureStub();
  const api = window.HelpdeskWidget;
  if (!api) return;

  if (!user) {
    if (typeof api.clearUser === 'function') {
      api.clearUser();
    } else if (Array.isArray(api.q)) {
      api.q.push({ __clear: true });
    }
    return;
  }

  const fullName =
    user.fullName || [user.name, user.surname].filter(Boolean).join(' ').trim() || '';

  api.setUser({
    email: user.email || '',
    fullName,
    phone: user.mobile || user.phone || '',
    lockEmail: true,
  });
}

function loadWidgetScript() {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[${SCRIPT_ATTR}]`)) return;

  ensureStub();

  const el = document.createElement('script');
  el.src = WIDGET_SRC;
  el.async = true;
  el.setAttribute('data-key', SCRIPT_KEY);
  el.setAttribute(SCRIPT_ATTR, '1');
  document.body.appendChild(el);
}

/**
 * İşletme (panel) helpdesk widget — web'e değil, sadece Gise panele gömülü.
 */
export default function HelpdeskWidget() {
  const { identity, isLoading } = useGetIdentity();
  const prevIdRef = useRef(undefined);

  useEffect(() => {
    loadWidgetScript();
  }, []);

  useEffect(() => {
    if (isLoading) return;

    if (identity?.id) {
      const cached = readPanelUser();
      syncHelpdeskUser({
        email: cached?.email || identity.email || '',
        fullName: identity.fullName || cached?.fullName || '',
        name: cached?.name,
        surname: cached?.surname,
      });
    } else if (prevIdRef.current) {
      syncHelpdeskUser(null);
    }

    prevIdRef.current = identity?.id;
  }, [identity, isLoading]);

  return null;
}
